<template>
    <!-- 详情界面 -->
    <el-dialog :visible.sync="dialogVisible" :title="title" width="80%" :close-on-click-modal="false">
        <div class="item_info border_Green">
            <el-descriptions class="margin-top" title="基本工资" :column="4" border>
                <el-descriptions-item>
                    <template slot="label">
                        所属门店
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.storeName }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        岗位名称
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.postName }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        年月
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.year }}年{{ monthSalary.month
                    }}月</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        基础薪资
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.baseSalary }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        岗位工资
                    </template>
                    {{ monthSalary.postWage }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        全勤补贴
                    </template>
                    {{ monthSalary.perfectAttendance }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        社保补贴
                    </template>
                    {{ monthSalary.socialSecuritySubsidy }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        工龄补贴
                    </template>
                    {{ monthSalary.seniorityPay }}
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div class="item_info border_Green">
            <el-descriptions class="margin-top" title="浮动工资" :column="4" border>
                <el-descriptions-item>
                    <template slot="label">
                        应出勤天数
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.requiredAttendance }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        实际出勤天数
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.realAttendance }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        实发金额
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.realMoeny }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        非办卡提成
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.notCardBonus }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        办卡提成
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.cardBonus }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        电话提成
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.phoneBonus }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        学校提成
                    </template>
                    {{ monthSalary.schoolBonus }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        提成合计
                    </template>
                    <span style="display: inline-block; width: 100px;color: red;font-weight: bold;">{{
                        parseFloat((monthSalary.schoolBonus +
                            monthSalary.notCardBonus +
                            monthSalary.cardBonus + monthSalary.phoneBonus).toFixed(2)) }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        应扣款金额
                    </template>
                    {{ monthSalary.subtractMoney }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        目标达成奖励
                    </template>
                    {{ monthSalary.finishedMoney }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        应补发金额
                    </template>
                    {{ monthSalary.reissueMoney }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        销售递增奖励
                    </template>
                    {{ monthSalary.salesIncreasing }}
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div class="item_info border_Green">
            <el-descriptions class="margin-top" title="维护信息" :column="4" border>
                <el-descriptions-item>
                    <template slot="label">
                        创建人
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.creator }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        创建时间
                    </template>
                    <span style="display: inline-block; width: 150px;">{{ monthSalary.createTime }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        维护人
                    </template>
                    <span style="display: inline-block; width: 100px;">{{ monthSalary.editor }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        维护时间
                    </template>
                    <span style="display: inline-block; width: 150px;">{{ monthSalary.updateTime }}</span>
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div class="item_info border_Green">
            <el-descriptions class="margin-top" title="导出记录" :column="4" border>
            </el-descriptions>
            <!-- 导出历史记录 -->
            <exportHistory ref="exportHistory"></exportHistory>
        </div>
        <span slot="footer">
            <el-button @click="dialogVisible = false" icon="el-icon-close" size="small">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    GetUserMonthSalaryDetail
} from "@/api/salaryApi.js";
import exportHistory from "@/components/common/exportHistory.vue";
export default {
    data() {
        return {
            title: "",
            loading: false, //是显示加载
            dialogVisible: false, //控制详情页面显示与隐藏
            monthSalary: {

            },
        };
    },
    computed: {},
    watch: {},
    created() {

    },
    mounted() { },
    components: {
        exportHistory,
    },
    methods: {
        //显示详情界面
        detailShow(row) {
            if (row != undefined && row != "undefined") {
                this.title = "详情";
                let parmer = {
                    keyId: row.keyId,
                };
                GetUserMonthSalaryDetail(parmer)
                    .then((res) => {
                        if (res.code == 1) {
                            this.monthSalary = res.data;
                            this.dialogVisible = true;
                            this.$nextTick(() => {
                                this.$refs.exportHistory.showExportHistory(this.monthSalary.keyId);
                            })
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("获取员工月度薪资详情失败!");
                    });
            } else {
                this.$message.error("请选择要查看的员工月度薪资详情!");
            }
        },
        // 关闭详情弹出框
        closeDialog() {
            this.dialogVisible = false;
            this.$data.monthSalary = this.$options.data.call(this).monthSalary;
        },
    },
};
</script>
<style scoped>
.selectContent {
    margin-top: 20rpx;
    display: flex;
    justify-content: center;
    align-items: center;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border-bottom: 2px solid #e9e7e7;
}

.border_Green {
    border-left: 5px solid #00cc66;
}
</style>